import { Component, OnInit,ViewChild } from '@angular/core';
import { GridBaseCase } from "../../grid/grid.base.case";
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll,IonSlides } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { computeStackId } from '@ionic/angular/dist/directives/navigation/stack-utils';
declare var app;
@Component({
  selector: 'app-a2-notice',
  templateUrl: './a2-notice.component.html',
  styleUrls: ['./a2-notice.component.scss']
})
export class A2NoticeComponent extends GridBaseCase {
  @ViewChild(IonSlides) slides:IonSlides;
  dataArrayList: Array<any> = [];
  dataArrayList1: Array<any> = [];
  slideOpts = {
    effect: "flip",  //轮播效果
    initialSlide: 0,
    speed: 2000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    }
  };
  checkMsgType: any;
  unReadMsgType = {type1:0,type2:0,type3:0,type4:0};//未读消息类型

  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) {super(); 
  
  //  this.slides.startAutoplay();
  }
  // EventLiink(item){
  //   this.com.setHistoryUrl();
  //   this.router.navigate(["/tabs/contact/NoticeDetail/View/"+item.id.value]);
  // }
  LoadData(PageNumber) {
    let that = this;
    // console.log(that.element);
    that.PageNumber = PageNumber;
    // if (PageNumber == 1) {
    //   that.loading = false;
    //   that.apiObj['status'] = false;
    //   that.apiObj['msg'] = '';
    // }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    that.loading = true;
      that.apiObj['status'] = true;
      that.apiObj['msg'] = '10086112111';
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // let seaobj={};
    // seaobj["v_FK_SystemUser_ID"]=that.com.GetAccount.Id;
    // seaobj["v_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore")["ID"];
    // body.RequestBody = JSON.stringify(seaobj);
    // if (!that.com.GetAccount.IsAdmin) {
    //   // console.log(that.month);
    //   if (!that.searchDate) {
    //     let startDate = that.com.getNow + " 00:00:00";
    //     let endDate = that.com.getNow + " 23:59:59";
    //     that.searchDate = that.com.BetweenDate(startDate, endDate);
    //   }
    //   // if (that.searchDate) {
    //   //   body.RequestBody = JSON.stringify({ "v_CreateTime": that.searchDate });
    //   // }
    // }
    body.RowsPerPage = 5;
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      // if(PageNumber == 1){
      //   that.dataArrayList = [];
      //   that.apiObj['status'] = data.ResponseMessage.Success;
      //   that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      //   that.loading = true;
      // }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
     
        data.Status.Datas.forEach(function (item) {

          let objfield = { 'num': { 'text': '数量', value: null } };
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text }; 
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text }; 
            }
            if (element.bindingField == 'date' && item[element.field]) {
              objfield[element.bindingField] = { "value": item[element.field].replace('00:00:00', '').replace(/-/g,"/"), "text": element.text};
            }
          });
          that.dataArrayList.push(objfield);
          // console.log("zmzmzm++++++++++++++++++++++")
          // console.log(that.dataArrayList);
        });
        if(that.dataArrayList.length>1){
          
          if(that.slides){
            that.slides.startAutoplay();
          }




          /**
           *处理消息已读未读
           */
          data.Status.Datas.forEach(function (item) {
            let objfield = {};
            objfield["read"]=item["a_IsRead"];
            objfield["msgType"]=item["a_MsgType"];

            switch ( item["a_MsgType"]) {
              case 1://通知
               objfield["msgType"] = "通知";
                break;
              case 2://公告
                objfield["msgType"] = "公告";
                break;
              case 3://提醒
                objfield["msgType"] = "提醒";
                break;
              case 4://警告
                objfield["msgType"] = "警告";
                break;
            }
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = item[element.field];
              }
              if (element.bindingField == 'date' && item[element.field]) {
                objfield[element.bindingField] = item[element.field].replace('00:00:00', '').replace(/-/g,"/");
              }
              // console.log(element,"shuju>>>>>>>>>>>>")
             
            });
            console.log(objfield)
            that.dataArrayList1.push(objfield);
            console.log("zm",that.dataArrayList1);
          });



          let readCount:number = 0;
          that.dataArrayList1.forEach(coutitem=>{
           
  
            if(!coutitem.status){
              readCount+=1;
              // console.log("显示的数量&&&&&&&&&&&&&&&&&&&&&&&&",readCount);
  
              //判断哪种消息类型具有未读的消息
              // if(that.checkMsgType == 0){
              //   that.unReadMsgType["type"+coutitem.msgType] = true;
              // }
              // if(that.checkMsgType == coutitem.msgType){
              //   that.unReadMsgType["type"+coutitem.msgType] = true;
              // }
            }
          });
          if(readCount){
            localStorage.setItem("readCount",readCount.toString());
          }else{
            localStorage.removeItem("readCount");
          }
        }
        
        /****上拉加载数据begin****/
     
        /****上拉加载数据end****/
      }

    }).catch(error => {
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      // that.loading = true;
      console.log(error);
    })
  }
  EventLiink(ev: any, parms: any) {
    // console.log("zmmmmmmmmmmmmmmmmmmmmm**************",parms);
    const that = this;
    let evs = ev.url || '';
    
    if (evs.trim() && parms) {
      that.com.setHistoryUrl();
      if (evs.indexOf("http") > 0) {
        that.com.goWebPage(evs, '详情');

        console.log(evs, parms);
      } else {
       
        console.log(parms);
       
        if(parms.read==0){
          that.readNotice(parms);
        }
       
        this.com.setHistoryUrl();
        console.log(evs);
        // this.router.navigate(["/tabs/contact/NoticeDetail/View/"+parms.id]);
        this.com.Go("/tabs/contact/NoticeDetail/View/"+parms.id);
        // that.router.navigateByUrl([evs + "View/" + parms.id.value]+"&"+that.com.getNowDatetime);
        
      }
    }

  }


  /**
   * 设置消息为已读
   * @param parms 
   */
  readNotice(parms) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "MarkMessageRead";//临时拜访
    body.OpType = "add";
    body.ConfigType = "form";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Content";
    body.Client.Name = null;
    body.Client.ClientType = 2;
    let arrayobj = { "type": 1, "ids": [] };
    // let IDs = that.actRouter.snapshot.paramMap.get('id');
    let _arrayobj = {};
    _arrayobj["ID"] = parms.id;
    _arrayobj["MsgType"] = parms.msgType;
    arrayobj.ids.push(_arrayobj);
    // console.log(arrayobj,'arrayobj');
    body.RequestBody = JSON.stringify(arrayobj);
      that.http.post(app.DEFAULTURL, body).then(
        data => {
          if (data.ResponseMessage.Success) {
            let arrayalert:Array<any>=new Array<any>();
            let recount:number =0;
            if(localStorage.getItem("readCount")){

               recount = Number.parseInt(localStorage.getItem("readCount"));
            }
            
            let messageUnlock = that.com.GetStorageKey("lock");
            if(messageUnlock){
              if(messageUnlock.alertmessage.length>0){
                messageUnlock.alertmessage.forEach(item=>{
                  if(item.id!=parms.id){
                    arrayalert.push(item);
                  }else{
                    recount-=1;
                  }
                });
              }
              messageUnlock.alertmessage=arrayalert;
              localStorage.setItem("lock",JSON.stringify(messageUnlock));
              localStorage.setItem("readCount",recount.toString());
            }
          }
        }
      )
  }

}
